import React from 'react'
import classes from "./style.module.scss";
import { Images } from '../../../../assets';

const ProductsOverview = () => {
    return (
        <div className={`eventWrapper`}>
            <div className={`component-title flex items-center`}>
                <div className='label'>Products Overview</div>
                <div className='vector'></div>
            </div>

        </div>
    )
}

export default ProductsOverview